<template>
  <div>
      <div class="offer-header">
          <div class="page-title">
              <h4> {{$t('txt.creeazaFactura')}} </h4>
          </div>
          <div class="action-button-group">
            <div class="preview-template-button action-button" :class="{'action-button-active': action_button_state === 1}">
                <button type="button" @click="showModal()">
                    <i class="far fa-eye"></i>
                </button>
                <div class="teardrop-text">
                  <span> Previzualizeaza </span>
                </div>
            </div>
              <div class="preview-products-list action-button" :class="{'action-button-active': action_button_state === 2}">
                <button type="button" @click="toggleSlideOut('products')" v-shortkey="['alt', '2']" @shortkey="toggleSlideOut('products')">
                    <i class="fas fa-th"></i>
                </button>
                <div class="teardrop-text">
                  <span> Adauga produse </span>
                </div>
            </div>
            <div class="preview-offers-list action-button" :class="{'action-button-active': action_button_state === 3}">
                <button type="button" @click="toggleSlideOut('offers')" v-shortkey="['alt', '3']" @shortkey="toggleSlideOut('offers')">
                    <i class="far fa-list-alt"></i>
                </button>
                <div class="teardrop-text">
                  <span> Adauga oferte </span>
                </div>
            </div>
            <div class="preview-orders-list action-button" :class="{'action-button-active': action_button_state === 5}">
               <button type="button" @click="toggleSlideOut('orders')" v-shortkey="['alt', '5']" @shortkey="toggleSlideOut('orders')">
                    <i class="far fa-list-alt"></i>
                </button>
                <div class="teardrop-text">
                  <span> Adauga comenzi </span>
                </div>
            </div>
            <div class="preview-template-button action-button" :class="{'action-button-active': action_button_state === 4}">
              <button type="button" @click="toggleSlideOut('table-config')" v-shortkey="['alt', '4']" @shortkey="toggleSlideOut('table-config')">
                  <i class="fas fa-network-wired"></i>
              </button>
              <div class="teardrop-text">
                <span> Configurare Tabel </span>
              </div>
            </div>
          </div>
      </div>
      <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12">
              <clients ref="clientCompRef" :select_client_clone='select_client_clone'/>
          </div>
      </div>
      <div class="composition-template" id='composition-template-event'>
        <!-- <div class="template-composition-header">
          <b-form-checkbox
                  :title="check_addition ? 'Afiseaza adaos' : 'Ascunde adaos'"
                  v-model="check_addition"
                   @change="check_addition = !check_addition"
                   name="check-addition-button"
                   switch
                   >
          </b-form-checkbox>
        </div> -->
          <div class="general-template-info">
            <ul id="template-info-list">
                <li class="template-list-item">
                    <p class="main-heading"> {{$t('txt.numarFactura')}}: </p>
                    <p> AUTO  </p>
                </li>
                <li class="template-list-item">
                    <p class="main-heading"> {{$t('txt.data')}}:  </p>
                    <p> {{new Date() | moment("DD.MM.YYYY")}} </p>
                </li>
                <li class="template-list-item">
                    <p class="main-heading"> {{$t('txt.dataScadenta')}}  </p>
                    <date-picker v-model="due_date" value-type="format" type="date" lang="ro" format="DD-MM-YYYY"></date-picker>
                </li>
                <li class="template-list-item">
                    <button class="template-button" @click="cancelDocument('pending_invoice', '/invoices')">
                        Anuleaza factura
                    </button>
                </li>
            </ul>
          </div>
          <div class="offer-table-wrapper">
              <table>
                  <thead>
                  <tr>
                      <th>
                          <p>
                              {{$t('tableHeader.nrCrt')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['name_check'].value">
                          <p  class="final-table-header">
                              {{$t('placeholder.denumire')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['price_check'].value" class="tablehead-price">
                          <div class="type-price-header">
                              <p> {{$t('placeholder.tipPret')}} </p>
                              <b-form-select v-model="globalPriceRange.key" @change="changePriceProducts()">
                                  <option v-for="(ppCateg, index) in priceCategoryes" :key="index" :value="ppCateg.value">{{ ppCateg.display }}</option>
                              </b-form-select>
                          </div>
                      </th>
                      <th v-if="!checkboxes['addition_check'].value">
                          <p class="final-table-header">
                              {{$t('tableHeader.adaos')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['discount_check'].value">
                          <p class="final-table-header">
                              {{$t('tableHeader.discount')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['quantity_check'].value">
                          <p class="final-table-header">
                              {{$t('placeholder.cantitate')}}
                          </p>
                      </th>
                      <th v-if="!checkboxes['subtotal_check'].value">
                          <p class="final-table-header">
                              {{$t('txt.subtotal')}}
                          </p>
                      </th>
                      <th>
                          <p class="final-table-header">
                              <!-- {{$t('placeholder.sterge')}} -->
                          </p>
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(invoice_row, index) in invoice_rows.products" :data-order-row-id="invoice_row.id" :key="invoice_row.id">
                      <td >
                          <p> {{index + 1}} </p>
                      </td>
                      <td v-if="!checkboxes['name_check'].value" :tableheadData="$t('placeholder.denumire')" class="order-prdname-wrapper" :class="(parseFloat(invoice_row.prices['pp_minim']) > parseFloat(invoice_row.price)) ? 'price-under-min' : ''">
                          <div class="final-offer-name final-order-name">
                              <p> {{invoice_row.name}} </p>
                          </div>
                      </td>
                      <td v-if="!checkboxes['price_check'].value" :tableheadData="$t('placeholder.pret')">
                          <div class="type-price">
                              <b-form-select v-model="invoice_row.price_category" @change="changePriceProduct(index)">
                                      <option v-for="(ppCateg, index) in priceCategoryes" :key="index" :value="ppCateg.value"> {{ ppCateg.display }} &nbsp; | &nbsp; {{ invoice_row.prices[ppCateg.name] }}</option>
                              </b-form-select>
                              <i v-if="invoice_row.price_category_indicator === 'up' " class="fas fa-plus"></i>
                              <i v-if="invoice_row.price_category_indicator === 'down' " class="fas fa-minus"></i>
                              <i v-if="invoice_row.price_category_indicator !== 'down' && invoice_row.price_category_indicator !== 'up'" class="far fa-circle"></i>
                              <input type="number" v-model="invoice_row.price" :data-price-active="index"  @input="changePriceProductInput(index)" @click="activatePriceInput(index)" @keypress.enter="increaseDataPrice()"/>
                          </div>
                      </td>
                      <td v-if="!checkboxes['addition_check'].value" :tableheadData="$t('tableHeader.adaos')" class="price-modifier-wrapper">
                          <div class="modifier-wrapper">
                            <div class="item-price-modifier addition-modifier" v-bind:class="{'addition-modifier-inactive': check_addition}">
                                <input type="number" v-model="invoice_row.addition" :data-addition-active="index" min="1" max="100"
                                                    @input="inputAdditionProduct(index)"
                                                    @change="changeAdditionDiscountProduct(index)"
                                                    @keypress.enter="increaseDataAddition()"
                                                    @click="activateAdditionInput(index)">
                                <i class="fas fa-percentage"></i>
                            </div>
                            <i class="fas fa-arrow-down arrow-cursor" @dblclick="changeAdditionUnder(index)"></i>
                          </div>
                      </td>
                      <td v-if="!checkboxes['discount_check'].value" :tableheadData="$t('tableHeader.discount')" class="price-modifier-wrapper">
                          <div class="modifier-wrapper">
                            <div class="item-price-modifier">
                                <input type="number" v-model="invoice_row.discount" :data-discount-active="index" min="1" max="100"
                                                    @input="inputDiscountProduct(index)"
                                                    @change="changeAdditionDiscountProduct(index)"
                                                    @keypress.enter="increaseDataDiscount()"
                                                    @click="activateDiscountInput(index)">
                                <i class="fas fa-percentage"></i>
                            </div>
                            <i class="fas fa-arrow-down arrow-cursor" @dblclick="changeDiscountUnder(index)"></i>
                          </div>
                      </td>
                      <td width="10%" v-if="!checkboxes['quantity_check'].value" :tableheadData="$t('placeholder.cantitate')">
                          <div class="item-qty-modifier">
                              <input type="number" v-model="invoice_row.qty" :data-qty-active="index" min="1"
                                                    @keypress.enter="increaseDataQty()"
                                                    @keyup="checkQuantity(invoice_row, [invoice_row.qty],invoice_row.orderId, invoice_row.offerId)"
                                                    @click="activateQtyInput(index)"
                                                    @change="invoice_rows.products[index].qty = invoice_rows.products[index].qty !== '' ? invoice_rows.products[index].qty : 1">
                              <span>{{invoice_row.um}}</span>
                          </div>
                      </td>
                      <td v-if="!checkboxes['subtotal_check'].value" :tableheadData="$t('txt.subtotal')">
                          <div class="final-offer-price">
                              <!-- <p> {{(order_row.price * order_row.qty) + (order_row.addition || 0)/100*(order_row.price * order_row.qty) - (order_row.discount || 0)/100*(order_row.price * order_row.qty)  | formatPrice}} </p> -->
                              <p> {{(invoice_row.price * invoice_row.qty) | formatPrice}} </p>
                              <!--<p> RON </p>-->
                          </div>
                      </td>
                      <td :tableheadData="$t('placeholder.sterge')">
                          <div class="final-offer-remove" @click="removeItem(index, 'products')">
                              <i class="fas fa-times"></i>
                          </div>
                      </td>
                  </tr>
                </tbody>
              </table>
          </div>
      </div>
      <div class="composition-info">
          <ul>
              <li>
                  <h5> {{$t('txt.subtotal')}}  </h5>
                  <p> {{this.subtotal | formatPrice}} </p>
              </li>
             <li>
                  <h5> {{$t('tableHeader.discount')}}  </h5>
                  <span class="discount-label"> <i class="fas fa-percentage"></i> </span>
                  <input type="number" v-model="discount" min="1" max="100">
              </li>
              <li>
                  <h5> {{$t('txt.total')}}  </h5>
                  <p> {{this.total | formatPrice}}</p>
              </li>
              <li>
              <div class="discount-check-line">
                  <b-form-checkbox
                  v-b-tooltip.hover :title="totalDiscountCheckbox ?  'Nu afisa in factura' : 'Afiseaza in factura'"
                  name="discount-check"
                  v-model="totalDiscountCheckbox"
                  >
                  </b-form-checkbox>
                  <h5> Discount total </h5>
                </div>
                <p> {{this.discountTotal().value | formatPrice}} ({{this.discountTotal().percentage | formatPrice}} %) </p>
              </li>
              <li class="addition-info-line" v-if="!check_addition" v-bind:class="{'addition-modifier-inactive': check_addition}">
                <h5> Adaos total </h5>
                <p> {{this.addition.value | formatPrice}} ({{this.addition.percentage | formatPrice}} %) </p>
              </li>
              <li class="final-info-save">
                <button class="template-button" type="button" @click="saveInvoice()">
                    <i class="far fa-save"></i>
                    {{$t('placeholder.salveazaFactura')}}
                </button>
              </li>
          </ul>
      </div>
      <div class="table-config-slideout">
          <div id="table-column-config">
              <div class="table-config-close" @click="tableConfigClose()">
                  <p> <i class="fas fa-times"></i> </p>
              </div>
              <div :key="checkboxesKey">
                  <div class="table-checkbox-container" v-for="(checkbox, key) in checkboxes" :id="key" :key="key">
                      <template v-if="key === 'addition_check' && hideAddition">
                          <span> {{checkbox.name}}</span>
                          <b-form-checkbox
                                  v-b-tooltip.hover :title="checkbox.value ? 'Afiseaza' : 'Ascunde'"
                                  v-model="checkbox.value"
                                  :name="key"
                                  @change="changeCheckbox(key)"
                                  switch
                          >
                          </b-form-checkbox>
                      </template>
                      <template v-else-if="key !== 'addition_check'">
                          <span> {{checkbox.name}} </span>
                          <b-form-checkbox
                                  v-b-tooltip.hover :title="checkbox.value ? 'Afiseaza' : 'Ascunde'"
                                  v-model="checkbox.value"
                                  :name="key"
                                  @change="changeCheckbox(key)"
                                  switch
                          >
                          </b-form-checkbox>
                      </template>
                  </div>
              </div>
          </div>
      </div>
      <div id="product-slideout" class="closest-wrapper">
          <products :userWarehouses="this.userWarehouses"
                    :warehouses="this.warehouses"
                    @addItem="addItem"/>
      </div>
      <div id="offers-slideout">
          <productsfromoffer :select_client="this.select_client"
                             :warehouses="this.warehouses"
                             @addItem="addItem"
                             @removeItemFromOffer="removeItemFromOffer"/>

      </div>
      <div id="orders-slideout">
        <productsfromorder :client="this.select_client"
                            :warehouses="this.warehouses"
                            @addItem="addItem"
                            @removeItemFromOrder="removeItemFromOrder"/>

      </div>
      <b-modal id="modal-scrollable" size="xl" scrollable hide-header no-close-on-backdrop>
          <template slot="default">
              <div class="offer-header">
                  <div class="page-title">
                      <h5> Previzualizare factura </h5>
                  </div>
              </div>
              <div class="general-template-info">
                <ul>
                    <li>
                        <p class="main-heading"> {{$t('txt.numarFactura')}} </p>
                        <p> AUTO  </p>
                    </li>
                    <li>
                        <p class="main-heading"> {{$t('txt.data')}}  </p>
                        <p> {{new Date() | moment("DD.MM.YYYY")}} </p>
                    </li>
                </ul>
              </div>
              <div class="row justify-content-center">
                <div class="col-xl-6 col-lg-6 col-md-12">
                  <ul class="template-offer-details" v-if="select_client">
                      <h4> {{$t('txt.dateClient')}} </h4>
                      <li> <span> {{$t('placeholder.numeCompanie')}}: </span> <p>{{select_client.company_name ? select_client.company_name : '-'}} </p> </li>
                      <li> <span> {{$t('placeholder.nume')}}: </span> <p>{{select_client.last_name}} {{select_client.first_name}} </p> </li>
                      <li> <span> {{$t('placeholder.email')}}: </span> <p>{{select_client.email}} </p> </li>
                      <li> <span> {{$t('placeholder.telefon')}}: </span> <p>{{select_client.phone}} </p> </li>
                  </ul>
                </div>
              </div>
              <h4> {{$t('txt.facturaFinala')}} </h4>
              <div class="table-responsive">
                  <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>
                              <span>
                                  {{$t('tableHeader.nrCrt')}}
                              </span>
                          </th>
                            <th>
                                <span>
                                    {{$t('placeholder.denumire')}}
                                </span>
                            </th>
                            <th>
                                <span>
                                    {{$t('placeholder.cantitate')}}
                                </span>
                            </th>
                            <th style="text-align: right">
                                <span>
                                    {{$t('placeholder.pret')}}
                                </span>
                            </th>
                            <th style="text-align: right">
                                <span>
                                    {{$t('txt.subtotal')}}
                                </span>
                            </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice_row,index) in invoice_rows.products" :key="`modal-products-${index}`">
                            <td>
                                <p> {{index + 1}} </p>
                            </td>
                            <td  :tableheadData="$t('placeholder.denumire')">
                                <span> {{invoice_row.name}} </span>
                            </td>
                            <td :tableheadData="$t('placeholder.cantitate')">
                                <div style="text-align: center;">
                                    <p>
                                      {{invoice_row.qty}}
                                      <span>{{invoice_row.um}}</span>
                                    </p>
                                </div>
                            </td>
                            <td  :tableheadData="$t('placeholder.pret')" style="text-align: right">
                                <span> {{invoice_row.price | formatPrice}} </span>
                            </td>
                            <td :tableheadData="$t('txt.subtotal')" style="text-align: right">
                                <span> {{(invoice_row.price * invoice_row.qty) | formatPrice}} </span>
                            </td>
                        </tr>
                      </tbody>
                  </table>
              </div>
              <ul class="template-preview-total">
                  <li>
                      <h5> Adaos total  </h5>
                      <p> {{this.addition.value | formatPrice}} ({{this.addition.percentage | formatPrice}} %) </p>
                  </li>
                  <li>
                      <h5> {{$t('txt.subtotal')}}  </h5>
                      <p> {{this.subtotal | formatPrice}} </p>
                  </li>
                  <li>
                      <h5> {{$t('tableHeader.discount')}}  </h5>
                      <p> {{this.discountTotal().value | formatPrice}} ({{this.discountTotal().percentage | formatPrice}} %) </p>
                  </li>
                  <li>
                      <h5> {{$t('txt.total')}}  </h5>
                      <p> {{this.total | formatPrice}}</p>
                  </li>
              </ul>
          </template>
          <template slot="modal-footer">
              <div class="modal-certified-label">
                  <div class="modal-certified-logo">
                      <img src="/logo.png" alt="user-logo">
                  </div>
                  <p v-if="$hasRole(['partner'])"> {{$t('placeholder.partenerCompanie')}} </p>
              </div>
              <div class="modal-bottom-wrapper">
                  <button type="button" class="template-button" @click="closeModal()">
                      {{$t('txt.inchide')}}
                  </button>
              </div>
          </template>
      </b-modal>
  </div>
</template>

<script>

import ServicesService from '../../api-services/services.service'
import ProductsService from '../../api-services/products.service'
import InvoiceService from '../../api-services/invoices.service'
import DatePicker from 'vue2-datepicker'
import localforage from 'localforage'
import Products from '../../components/Products'
import ProductsFromOrder from '../../components/ProductsFromOrder'
import ProductsFromOffer from '../../components/ProductsFromOffer'
import { EventBus } from '../../main.js'
import Clients from '../../components/Clients'

export default {
  name: 'CreateOrder',
  data () {
    return {
      action_button_state: undefined,
      check_addition: false,
      userWarehouses: null,
      warehouses: null,
      lastRequest: null,
      selected: null,
      globalPriceRange: {
        key: 5,
        name: 'pp_amanunt'
      },
      priceCategoryes: null,
      checkboxes: {
        name_check: { value: false, name: 'Denumire' },
        price_check: { value: false, name: 'Tip pret' },
        addition_check: { value: true, name: 'Adaos' },
        discount_check: { value: true, name: 'Discount' },
        quantity_check: { value: false, name: 'Cantitate' },
        subtotal_check: { value: false, name: 'Subtotal' }
      },
      select_client_clone: null,
      selected_search_header: null,
      products: null,
      services: null,
      post_services: null,
      select_client: null,
      search_services: '',
      search_post_services: '',
      selected_label: null,
      discount: 0,
      invoice_rows: {
        products: [],
        services: [],
        post_services: []
      },
      counties: [],
      meta_products: {},
      meta_services: {},
      meta_post_services: {},
      select_partner: null,
      due_date: null,
      lastDataPriceActive: null,
      lastDataAdditionActive: null,
      lastDataDiscountActive: null,
      meta_products_page: 1,
      totalDiscountCheckbox: false,
      discountTotalArray: null,
      hideAddition: true,
      checkboxesKey: 1,
      lastDataQtyActive: null,
      invoiceErrors: {},
      compHistory: null
    }
  },
  components: {
    'date-picker': DatePicker,
    'products': Products,
    'productsfromorder': ProductsFromOrder,
    'productsfromoffer': ProductsFromOffer,
    'clients': Clients
  },
  watch: {
    client: function (value, oldValue) {
      if (value == null) {
        EventBus.$emit('clearUserOrders', true)
        this.select_partner = null
        this.select_client_form_status = false
      } else {
        this.checked = true
      }
    }
  },
  methods: {
    showModal () {
      this.action_button_state = 1
      this.$bvModal.show('modal-scrollable')
      let tableConfig = document.getElementById('table-column-config')
      tableConfig.classList.remove('config-active')
    },
    closeModal () {
      this.action_button_state = undefined
      this.$bvModal.hide('modal-scrollable')
    },
    activateQtyInput (index) {
      this.lastDataQtyActive = index
      window.$('[data-qty-active=' + this.lastDataQtyActive + ']').focus().select()
    },
    increaseDataQty () {
      this.lastDataQtyActive = this.lastDataQtyActive < this.invoice_rows.products.length - 1 ? this.lastDataQtyActive + 1 : this.lastDataQtyActive
      window.$('[data-qty-active=' + this.lastDataQtyActive + ']').focus().select()
    },
    removeItemFromOffer (data) {
      let index = this.invoice_rows.products.findIndex(el => el.id === data.productId && el.offerId === data.offerId)
      if (index >= 0) {
        this.invoice_rows.products.splice(index, 1)
      }
    },
    changeCheckbox (name) {
      if (name === 'addition_check') {
        if (this.checkboxes[name].value === true) {
          if (confirm('Sunteti sigur?')) {
            this.checkboxes[name].value = !this.checkboxes[name].value
          }
        } else {
          this.checkboxes[name].value = !this.checkboxes[name].value
        }
      } else {
        this.checkboxes[name].value = !this.checkboxes[name].value
      }
      this.checkboxesKey++
    },
    tableConfigClose () {
      this.action_button_state = undefined
      let tableConfig = document.getElementById('table-column-config')
      tableConfig.classList.remove('config-active')
      this.$root.$emit('bv::hide::tooltip')
    },
    activatePriceInput (index) {
      this.lastDataPriceActive = index
      window.$('[data-price-active=' + this.lastDataPriceActive + ']').focus().select()
    },
    activateAdditionInput (index) {
      this.lastDataAdditionActive = index
      window.$('[data-addition-active=' + this.lastDataAdditionActive + ']').focus().select()
    },
    activateDiscountInput (index) {
      this.lastDataDiscountActive = index
      window.$('[data-discount-active=' + this.lastDataDiscountActive + ']').focus().select()
    },
    increaseDataPrice () {
      this.lastDataPriceActive = this.lastDataPriceActive < this.invoice_rows.products.length - 1 ? this.lastDataPriceActive + 1 : this.lastDataPriceActive
      window.$('[data-price-active=' + this.lastDataPriceActive + ']').focus().select()
    },
    increaseDataAddition () {
      this.lastDataAdditionActive = this.lastDataAdditionActive < this.invoice_rows.products.length - 1 ? this.lastDataAdditionActive + 1 : this.lastDataAdditionActive
      window.$('[data-addition-active=' + this.lastDataAdditionActive + ']').focus().select()
    },
    increaseDataDiscount () {
      this.lastDataDiscountActive = this.lastDataDiscountActive < this.invoice_rows.products.length - 1 ? this.lastDataDiscountActive + 1 : this.lastDataDiscountActive
      window.$('[data-discount-active=' + this.lastDataDiscountActive + ']').focus().select()
    },

    toggleSlideOut (target) {
      let sliderOffers = document.getElementById('offers-slideout')
      let sliderOrders = document.getElementById('orders-slideout')
      let sliderProducts = document.getElementById('product-slideout')
      let mainContainer = document.getElementById('page-content-wrapper')
      let searchProducts = document.getElementById('product-search')
      let searchProductsOrders = document.getElementById('product-search-order')
      let tableConfig = document.getElementById('table-column-config')
      switch (target) {
        case 'products':
          this.action_button_state = 2
          sliderOffers.classList.remove('slideout-open')
          sliderOrders.classList.remove('slideout-open')
          sliderProducts.classList.add('slideout-open')
          mainContainer.classList.add('changed-position')
          tableConfig.classList.remove('config-active')
          searchProducts.focus()
          break
        case 'orders':
          this.action_button_state = 5
          sliderOffers.classList.remove('slideout-open')
          sliderProducts.classList.remove('slideout-open')
          sliderOrders.classList.add('slideout-open')
          mainContainer.classList.add('changed-position')
          tableConfig.classList.remove('config-active')
          searchProductsOrders.focus()
          break
        case 'offers':
          this.action_button_state = 3
          sliderOrders.classList.remove('slideout-open')
          sliderProducts.classList.remove('slideout-open')
          sliderOffers.classList.add('slideout-open')
          mainContainer.classList.add('changed-position')
          tableConfig.classList.remove('config-active')
          searchProductsOrders.focus()
          break
        case 'table-config':
          this.action_button_state = 4
          mainContainer.classList.remove('changed-position')
          sliderOrders.classList.remove('slideout-open')
          sliderProducts.classList.remove('slideout-open')
          sliderOffers.classList.remove('slideout-open')
          tableConfig.classList.add('config-active')
          break
        default:
      }
      this.addBodyClass()
    },
    closeSlideout () {
      this.action_button_state = undefined
      window.$('.action-button').removeClass('action-button-active')
      window.$('#orders-slideout').removeClass('slideout-open')
      window.$('#offers-slideout').removeClass('slideout-open')
      window.$('#product-slideout').removeClass('slideout-open')
      window.$('#page-content-wrapper').removeClass('changed-position')
      this.addBodyClass()
    },
    changePriceProducts () {
      let priceCat = this.priceCategoryes.find(price => parseInt(price.value) === parseInt(this.globalPriceRange.key))
      this.globalPriceRange.name = priceCat.name
      for (let i = 0; i < this.invoice_rows.products.length; i++) {
        this.invoice_rows.products[i].price_category = this.globalPriceRange.key
        this.invoice_rows.products[i].price = this.invoice_rows.products[i].prices[this.globalPriceRange.name]
        this.invoice_rows.products[i].price_fixed = this.invoice_rows.products[i].prices[this.globalPriceRange.name]
        this.invoice_rows.products[i].price_category_name = this.globalPriceRange.name
        this.invoice_rows.products[i].price_category_indicator = 'stable'
        this.invoice_rows.products[i].addition = parseFloat((this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_minim) / this.invoice_rows.products[i].prices.pp_minim * 100).toFixed(2)
        this.invoice_rows.products[i].discount = parseFloat(-(this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices['pp_amanunt']) / this.invoice_rows.products[i].prices['pp_amanunt'] * 100).toFixed(2)
      }
    },
    changePriceProduct (i) {
      let priceCat = this.priceCategoryes.find(price => price.value === this.invoice_rows.products[i].price_category)
      this.invoice_rows.products[i].price = this.invoice_rows.products[i].prices[priceCat.name]
      this.invoice_rows.products[i].price_category_name = priceCat.name
      this.invoice_rows.products[i].price_category_indicator = 'stable'
      this.invoice_rows.products[i].addition = parseFloat((this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_minim) / this.invoice_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.invoice_rows.products[i].discount = parseFloat(-(this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_amanunt) / this.invoice_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.invoice_rows.products[i].price_fixed = this.invoice_rows.products[i].price
    },
    changePriceProductInput (i) {
      this.invoice_rows.products[i].addition = parseFloat((this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_minim) / this.invoice_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.invoice_rows.products[i].discount = parseFloat(-(this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_amanunt) / this.invoice_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.invoice_rows.products[i].discount = this.invoice_rows.products[i].discount > 0 ? this.invoice_rows.products[i].discount : parseFloat(0.00).toFixed(2)
      this.machProductPriceCategory(i)
      this.invoice_rows.products[i].price_fixed = this.invoice_rows.products[i].price
    },
    inputDiscountProduct (i) {
      let prodDiscount = this.invoice_rows.products[i].discount > 0 ? this.invoice_rows.products[i].discount : 0
      this.invoice_rows.products[i].price = parseFloat(this.invoice_rows.products[i].price_fixed - prodDiscount / 100 * this.invoice_rows.products[i].price_fixed)
      this.invoice_rows.products[i].old_discount_fixed = this.invoice_rows.products[i].discount
      this.machProductPriceCategory(i)
    },
    inputAdditionProduct (i) {
      let prodAddition = this.invoice_rows.products[i].addition > 0 ? this.invoice_rows.products[i].addition : 0
      this.invoice_rows.products[i].price = parseFloat(Number(this.invoice_rows.products[i].price_fixed) + Number(prodAddition) / 100 * Number(this.invoice_rows.products[i].price_fixed))
      this.invoice_rows.products[i].old_addition_fixed = this.invoice_rows.products[i].addition
      this.machProductPriceCategory(i)
    },
    changeAdditionDiscountProduct (i) {
      this.changeInputNull(i)
      this.invoice_rows.products[i].price_fixed = parseFloat(this.invoice_rows.products[i].price).toFixed(2)
      this.invoice_rows.products[i].addition = parseFloat((this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_minim) / this.invoice_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.invoice_rows.products[i].addition = this.invoice_rows.products[i].addition > 0 ? this.invoice_rows.products[i].addition : parseFloat(0.00).toFixed(2)
      this.invoice_rows.products[i].discount = parseFloat(-(this.invoice_rows.products[i].price - this.invoice_rows.products[i].prices.pp_amanunt) / this.invoice_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.invoice_rows.products[i].discount = this.invoice_rows.products[i].discount > 0 ? this.invoice_rows.products[i].discount : parseFloat(0.00).toFixed(2)
      this.invoice_rows.products[i].price = parseFloat(this.invoice_rows.products[i].price).toFixed(2)
    },
    changeInputNull (i) {
      this.invoice_rows.products[i].addition = this.invoice_rows.products[i].addition > 0 ? this.invoice_rows.products[i].addition : parseFloat(0.00).toFixed(2)
      this.invoice_rows.products[i].discount = this.invoice_rows.products[i].discount > 0 ? this.invoice_rows.products[i].discount : parseFloat(0.00).toFixed(2)
    },
    machProductPriceCategory (index) {
      let prices = this.invoice_rows.products[index].prices
      prices = Object.keys(prices).map(function (key) {
        return { value: parseFloat(prices[key]), name: key }
      })
      prices.push({ value: parseFloat(this.invoice_rows.products[index].price), name: 'selected_price' })
      prices = prices.sort((a, b) => a.value >= b.value ? 1 : -1)

      let priceCatName = null
      let priceCatIndicator = 'stable'
      for (let i = 0; i < prices.length; i++) {
        if (prices[i].name === 'selected_price' && i === 0) {
          priceCatName = prices[i + 1].name
          if (prices[i].value === prices[i + 1].value) {
            priceCatIndicator = 'stable'
          } else {
            priceCatIndicator = 'down'
          }
          break
        }

        if (prices[i].name === 'selected_price' && i === prices.length - 1) {
          priceCatName = prices[i - 1].name
          if (prices[i].value === prices[i - 1].value) {
            priceCatIndicator = 'stable'
          } else {
            priceCatIndicator = 'up'
          }
          break
        }

        if (prices[i].name === 'selected_price') {
          if (prices[i].value === prices[i - 1].value) {
            priceCatName = prices[i - 1].name
            priceCatIndicator = 'stable'
            break
          }

          if (prices[i].value === prices[i + 1].value) {
            priceCatName = prices[i + 1].name
            priceCatIndicator = 'stable'
            break
          }

          if (prices[i].value <= (prices[i - 1].value + prices[i + 1].value) / 2) {
            priceCatName = prices[i - 1].name
            priceCatIndicator = 'up'
            break
          } else {
            priceCatName = prices[i + 1].name
            priceCatIndicator = 'down'
            break
          }
        }
      }

      let priceCat = this.priceCategoryes.find(p => p.name === priceCatName)
      if (priceCat) {
        this.invoice_rows.products[index].price_category_indicator = priceCatIndicator
        this.invoice_rows.products[index].price_category_name = priceCatName
        this.invoice_rows.products[index].price_category = priceCat.value
        return true
      } else {
        this.invoice_rows.products[index].price_category_indicator = null
        this.invoice_rows.products[index].price_category_name = null
        this.invoice_rows.products[index].price_category = null
        return null
      }
    },
    getServices (params) {
      return new Promise((resolve, reject) => {
        this.services = null
        ServicesService.getAll((params || { per_page: 20 }))
          .then((response) => {
            if (response.data.data.length > 0) {
              this.services = response.data.data
              for (let i = 0; i < this.services.length; i++) {
                this.$set(this.services[i], 'qty', 1)
                this.$set(this.services[i], 'discount', 0)
                this.$set(this.services[i], 'addition', 0)
              }
            } else {
              this.services = null
            }
            this.meta_services = response.data.meta
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    async applyQueryServices (params) {
      this.$store.dispatch('showLoading')
      let resetPage = { page: '1' }
      // params = _.pickBy(params)
      // merge 3 objects
      params.per_page = 20
      let query = { ...resetPage, ...params }
      await this.getServices(query)
      this.$store.dispatch('hideLoading')
    },
    async applyQueryPostServices (params) {
      this.$store.dispatch('showLoading')
      let resetPage = { page: '1' }
      // params = _.pickBy(params)
      // merge 3 objects
      params.per_page = 20
      let query = { ...resetPage, ...params }
      await this.getPostServices(query)
      this.$store.dispatch('hideLoading')
    },
    getWarehouses () {
      return new Promise((resolve, reject) => {
        ProductsService.getWarehouses()
          .then((response) => {
            this.warehouses = response.data.data.data
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    checkQuantity (product, inputs, orderId, offerId) {
      for (let i = 0; i < inputs.length; i++) {
        let checkValue = null
        if (typeof inputs[i] === 'object') {
          checkValue = inputs[i].value
        } else {
          checkValue = inputs
        }
        if (checkValue > 0) {
          if (product.stock.length > 0) {
            let stock = null
            if (typeof inputs[i] === 'object') {
              stock = product.stock.find(row => parseInt(row.warehouse_id) === parseInt(inputs[i].getAttribute('data-warehouse-id')))
            } else {
              stock = product.stock.find(row => parseInt(row.warehouse_id) === parseInt(product.warehouses[0].id))
            }
            if (stock) {
              let localProd = this.invoice_rows.products.find(prod => parseInt(prod.id) === parseInt(product.id) && parseInt(prod.orderId) !== parseInt(orderId) && parseInt(prod.offerId) !== parseInt(offerId))
              let localProdOrder = this.invoice_rows.products.find(prod => parseInt(prod.id) === parseInt(product.id) && parseInt(prod.orderId) === parseInt(orderId))
              let localProdOffer = this.invoice_rows.products.find(prod => parseInt(prod.id) === parseInt(product.id) && parseInt(prod.offerId) === parseInt(offerId))
              let existProdQty = localProd ? localProd.qty : 0
              let qtyAdd = null

              if (!orderId) {
                existProdQty = localProdOrder ? parseInt(existProdQty) + parseInt(localProdOrder.qty) : Number(0)
              }
              if (!offerId) {
                existProdQty = localProdOffer ? parseInt(existProdQty) + parseInt(localProdOffer.qty) : Number(0)
              }
              let depMsg = null
              if (typeof inputs[i] === 'object') {
                qtyAdd = parseInt(inputs[i].value) + parseInt(existProdQty)
                depMsg = inputs[i].getAttribute('data-warehouse-name')
              } else {
                qtyAdd = parseInt(inputs[i]) + parseInt(existProdQty)
                depMsg = product.warehouses[0].name
              }

              if (qtyAdd > parseInt(stock.qty)) {
                this.$notify({
                  group: 'warning',
                  type: 'warn',
                  text: 'Din pacate mai sunt doar ' + stock.qty + ' buc. pe stoc in depozitul ' + depMsg + ' pentru acest produs',
                  'animation-type': 'css'
                })
                if (!localProdOrder && orderId > 0) {
                  let objData = {
                    orderId: orderId,
                    productId: product.id
                  }
                  EventBus.$emit('uncheckFromOrder', objData)
                }

                if (!localProdOffer && offerId > 0) {
                  let objData = {
                    offerId: offerId,
                    productId: product.id
                  }
                  EventBus.$emit('uncheckFromOffer', objData)
                }
                return false
              } else {
                let productInvoice = this.invoice_rows.products.find(row => row.id === product.id)
                if (productInvoice) {
                  let warehouseInvoice = null
                  if (typeof inputs[i] === 'object') {
                    warehouseInvoice = productInvoice.warehouses.find(row => row.id === parseInt(inputs[i].getAttribute('data-warehouse-id')))
                  } else {
                    warehouseInvoice = productInvoice.warehouses.find(row => row.id === parseInt(product.warehouses[0].id))
                  }
                  let qtyAddVal = 0
                  let warehouseInvoiceQty = warehouseInvoice ? warehouseInvoice.qty : 0

                  let errMsg = null
                  if (typeof inputs[i] === 'object') {
                    qtyAddVal = parseInt(inputs[i].value) + parseInt(warehouseInvoiceQty)
                    errMsg = inputs[i].getAttribute('data-warehouse-name')
                  } else {
                    qtyAddVal = parseInt(inputs[i]) + parseInt(warehouseInvoiceQty)
                    errMsg = product.warehouses[0].name
                  }
                  if (warehouseInvoice && (qtyAddVal > parseInt(stock.qty))) {
                    this.$notify({
                      group: 'warning',
                      type: 'warn',
                      text: 'Din pacate mai sunt doar ' + stock.qty + ' buc. pe stoc in depozitul ' + errMsg + ' pentru acest produs',
                      'animation-type': 'css'
                    })
                    if (!localProdOrder && orderId > 0) {
                      let objData = {
                        orderId: orderId,
                        productId: product.id
                      }
                      EventBus.$emit('uncheckFromOrder', objData)
                    }
                    if (!localProdOffer && offerId > 0) {
                      let objData = {
                        offerId: offerId,
                        productId: product.id
                      }
                      EventBus.$emit('uncheckFromOffer', objData)
                    }
                    return false
                  }
                }
              }
            } else {
              let errMsg = null
              if (typeof inputs[i] === 'object') {
                errMsg = inputs[i].getAttribute('data-warehouse-name')
              } else {
                errMsg = product.warehouses[0].name
              }
              this.$notify({
                group: 'warning',
                type: 'warn',
                text: 'Din pacate nu aveti stoc in depozitul ' + errMsg + ' pentru acest produs',
                'animation-type': 'css'
              })
              if (orderId > 0) {
                let objData = {
                  orderId: orderId,
                  productId: product.id
                }
                EventBus.$emit('uncheckFromOrder', objData)
              }
              if (offerId > 0) {
                let objData = {
                  offerId: offerId,
                  productId: product.id
                }
                EventBus.$emit('uncheckFromOffer', objData)
              }
              return false
            }
          } else {
            this.$notify({
              group: 'warning',
              type: 'warn',
              text: 'Din pacate nu aveti stoc pentru acest produs',
              'animation-type': 'css'
            })
            if (orderId > 0) {
              let objData = {
                orderId: orderId,
                productId: product.id
              }
              EventBus.$emit('uncheckFromOrder', objData)
            }
            if (offerId > 0) {
              let objData = {
                offerId: offerId,
                productId: product.id
              }
              EventBus.$emit('uncheckFromOffer', objData)
            }
            return false
          }
        }
      }
      this.clearErrors(product.id)

      if (typeof inputs[0] !== 'object') {
        product.warehouses[0].qty = product.qty
      }
      return true
    },
    clearErrors (prodId) {
      delete this.invoiceErrors[prodId]
    },
    errorsLogo (product, qtyAdd, stockQty) {
      this.invoiceErrors[product.id] = {
        stock: stockQty,
        added: qtyAdd,
        name: product.name,
        warehouseName: product.warehouses[0].name
      }
    },
    removeItemFromOrder (data) {
      let index = this.invoice_rows.products.findIndex(el => el.id === data.productId && el.orderId === data.orderId)
      if (index >= 0) {
        this.invoice_rows.products.splice(index, 1)
      }
    },
    addItem (data) {
      let row = null
      if (data.orderId) {
        data.productInfo = data.product
        data.product = data.product.data
        row = this.invoice_rows.products.find(r => parseInt(r.id) === parseInt(data.product.id) && parseInt(r.orderId) === parseInt(data.orderId))
      } else if (data.offerId) {
        data.productInfo = data.product
        data.product = data.product.data
        row = this.invoice_rows.products.find(r => parseInt(r.id) === parseInt(data.product.id) && parseInt(r.offerId) === parseInt(data.offerId))
      } else {
        row = this.invoice_rows.products.find(r => parseInt(r.id) === parseInt(data.product.id) && r.orderId === null && r.offerId === null)
      }
      if (this.checkQuantity(data.product, data.inputs, data.orderId || null, data.offerId || null) === false) {
        return false
      }
      if (row) {
        let ok = false
        for (let i = 0; i < data.inputs.length; i++) {
          if (data.inputs[i].value > 0) {
            ok = true
            let warehouse = row.warehouses.find(warehouse => parseInt(warehouse.id) === parseInt(data.inputs[i].getAttribute('data-warehouse-id')))
            if (warehouse) {
              if (data.orderId) {
                warehouse.qty = parseInt(data.inputs[i].value)
              } else {
                warehouse.qty = parseInt(warehouse.qty) + parseInt(data.inputs[i].value)
              }
            } else {
              row.warehouses.push({
                id: data.inputs[i].getAttribute('data-warehouse-id'),
                name: data.inputs[i].getAttribute('data-warehouse-name'),
                key: data.inputs[i].getAttribute('data-warehouse-key'),
                qty: parseInt(data.inputs[i].value)
              })
            }
            if (!data.orderId && !data.offerId) {
              row.qty = parseInt(row.qty) + parseInt(data.inputs[i].value)
              data.inputs[i].value = null
            } else {
              row.qty = parseInt(data.inputs[i].value)
            }
          }
        }
        if (!ok) {
          this.$notify({
            group: 'error',
            type: 'error',
            // title: 'Added',
            text: 'Specificati cantitatea pentru adaugare',
            'animation-type': 'css'
          })
        }
      } else {
        let dataQty = []
        let ok = false
        let totalQty = 0
        for (let i = 0; i < data.inputs.length; i++) {
          if (data.inputs[i].value > 0) {
            if (data.product.stock.length > 0) {
              ok = true
              dataQty.push({
                id: data.inputs[i].getAttribute('data-warehouse-id'),
                name: data.inputs[i].getAttribute('data-warehouse-name'),
                key: data.inputs[i].getAttribute('data-warehouse-key'),
                qty: data.inputs[i].value
              })
              if (!data.orderId && !data.offerId) {
                totalQty = parseInt(totalQty) + parseInt(data.inputs[i].value)
                data.inputs[i].value = null
              } else {
                totalQty = parseInt(data.inputs[i].value)
              }
            } else {

            }
          }
        }
        if (ok) {
          let obj = {
            id: data.product.id,
            offerId: data.offerId || null,
            orderId: data.orderId || null,
            warehouses: dataQty,
            price_category: _.clone(this.globalPriceRange.key),
            price_category_name: _.clone(this.globalPriceRange.name),
            price: data.orderId ? data.productInfo.price : (data.offerId ? data.productInfo.price : data.product.prices[_.clone(this.globalPriceRange.name)]),
            price_fixed: data.orderId ? data.productInfo.price : (data.offerId ? data.productInfo.price : data.product.prices[_.clone(this.globalPriceRange.name)]),
            prices: data.product.prices,
            name: data.product.name,
            qty: totalQty,
            stock: data.product.stock,
            um: data.product.um
          }
          obj['addition'] = parseFloat((obj.price - data.product.prices.pp_minim) / data.product.prices.pp_minim * 100).toFixed(2)
          obj['discount'] = parseFloat(-(obj.price - data.product.prices['pp_amanunt']) / data.product.prices['pp_amanunt'] * 100).toFixed(2)

          this.invoice_rows.products.push(obj)

          this.changePriceProductInput(this.invoice_rows.products.lastIndexOf(obj))
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: 'Produsul a fost adaugat in factura',
            'animation-type': 'css'
          })

          if (!data.orderId && !data.offerId) {
            let searchProducts = document.getElementById('product-search')
            searchProducts.select()
            EventBus.$emit('lastDataActive', null)
            let collapsedAriaBtn = window.$('[aria-expanded=true]').attr('aria-controls')
            if (collapsedAriaBtn) {
              this.$root.$emit('bv::toggle::collapse', collapsedAriaBtn)
            }
          }
        } else {
          if (!ok) {
            this.$notify({
              group: 'error',
              type: 'error',
              // title: 'Added',
              text: 'Specificati cantitatea pentru adaugare',
              'animation-type': 'css'
            })
            if (data.orderId > 0) {
              let objData = {
                orderId: data.orderId,
                productId: data.product.id
              }
              EventBus.$emit('uncheckFromOrder', objData)
            }
            if (data.orderId > 0) {
              let objData = {
                orderId: data.orderId,
                productId: data.product.id
              }
              EventBus.$emit('uncheckFromOrder', objData)
            }
            return false
          }
        }
      }
      this.scrollToLastProduct(data, 'offer-table-wrapper')
    },
    removeItem (index, collection) {
      if (this.invoice_rows[collection][index].orderId !== null) {
        let data = {
          orderId: this.invoice_rows[collection][index].orderId,
          productId: this.invoice_rows[collection][index].id,
          warehouse: this.invoice_rows[collection][index].warehouses
        }
        EventBus.$emit('uncheckFromOrder', data)
      }
      if (this.invoice_rows[collection][index].offerId !== null) {
        let data = {
          offerId: this.invoice_rows[collection][index].offerId,
          productId: this.invoice_rows[collection][index].id,
          warehouse: this.invoice_rows[collection][index].warehouses
        }
        EventBus.$emit('uncheckFromOffer', data)
      }
      this.invoice_rows[collection].splice(index, 1)
    },
    async saveInvoice () {
      if (Object.keys(this.invoiceErrors).length) {
        for (let [key, val] of Object.entries(this.invoiceErrors)) {
          this.$notify({
            group: 'warning',
            type: 'warn',
            text: 'Din pacate mai sunt doar ' + this.invoiceErrors[key]['stock'] + ' buc. pe stoc in depozitul ' + this.invoiceErrors[key]['warehouseName'] + ' pentru produsul ' + this.invoiceErrors[key]['name'],
            'animation-type': 'css'
          })
          return false
        }
      }
      if (!this.select_client) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }

      let validatorResp = true
      await this.$refs.clientCompRef.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$refs.clientCompRef.$validator.errors && !result) {
          this.$refs.clientCompRef.select_client_form_status = true
          this.$refs.clientCompRef.checked = false
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }

      if (!this.due_date) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.dataScadenta'),
          'animation-type': 'css'
        })
        return false
      }
      if (this.invoice_rows.products.length === 0 /* && this.invoice_rows.services.length === 0 && this.invoice_rows.post_services.length === 0 */) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.facturaGoala'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.due_date) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.dataScadenta'),
          'animation-type': 'css'
        })
        return false
      }
      let data = {
        type: 1,
        client_id: this.select_client.id,
        client: this.select_client,
        products: this.invoice_rows.products,
        discount: this.discount,
        totalDiscount: this.discountTotal(),
        showTotalDiscount: this.totalDiscountCheckbox,
        due_date: this.due_date
      }
      // return false
      if (this.select_partner) {
        data['partner_id'] = this.select_partner.id
      }
      if (this.select_client) {
        data['company_name'] = this.select_client.company_name
        data['first_name'] = this.select_client.first_name
        data['last_name'] = this.select_client.last_name
        data['cui'] = this.select_client.cui
        data['nr_reg'] = this.select_client.nr_reg
        data['cnp'] = this.select_client.cnp
        data['ci_series'] = this.select_client.ci_series
        data['ci_number'] = this.select_client.ci_number
      }

      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      InvoiceService.create(data)
        .then((response) => {
          this.updateClientLocalforage(this.select_client)
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.facturaEmisa'),
            'animation-type': 'css'
          })
          this.invoice_rows = { products: [], services: [], post_services: [] }
          localforage.removeItem('pending_invoice').then((respones) => {
            this.$swal.fire({
              title: 'Factura creata cu succes!',
              icon: 'success',
              input: 'select',
              inputOptions: {
                print: 'Printeaza',
                download: 'Descarca',
                send: 'Trimite'
              },
              showCancelButton: true,
              closeButtonAriaLabel: 'Anuleaza',
              onClose: () => {
                this.$router.push('/invoices')
              }
            }).then((result) => {
              switch (result.value) {
                case 'download':
                  this.$router.push('/invoices')
                  this.downloadResource(process.env.VUE_APP_API_ENDPOINT + '/export/invoice-pdf/' + response.data.data.id)
                  break
                case 'print':
                  this.$router.push('/invoices')
                  window.open(response.data.data.media.link, '_blank')
                  break
                case 'send':
                  this.$swal.fire({
                    title: 'Trimite',
                    input: 'email',
                    inputValue: response.data.data.client.email || null,
                    inputPlaceholder: 'Adresa email client',
                    showCancelButton: true,
                    closeButtonAriaLabel: 'Anuleaza',
                    onClose: () => {
                      this.$router.push('/invoices')
                    }
                  }).then((result) => {
                    let data = {
                      resource_type: 'invoice',
                      resource_id: response.data.data.id,
                      email: result.value
                    }
                    this.sendEmailResource(data)
                  }).catch((error) => {
                    console.log(error)
                  })
                  break
              }
            })
          })
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
          this.closeSlideout()
        })
    },
    discountTotal () {
      let totalMax = 0
      this.invoice_rows.products.forEach(function (element) {
        totalMax += parseFloat(element.prices.pp_amanunt).toFixed(2) * parseInt(element.qty)
      })
      let disscountTotal = {}
      disscountTotal.value = -(parseFloat(this.total).toFixed(4) - parseFloat(totalMax).toFixed(4))
      disscountTotal.value = disscountTotal.value > 0 ? disscountTotal.value : 0.00
      disscountTotal.percentage = ((100 * parseFloat(disscountTotal.value).toFixed(2)) / parseFloat(totalMax).toFixed(2)) || 0
      disscountTotal.percentage = disscountTotal.percentage > 0 ? disscountTotal.percentage : 0.00
      return disscountTotal
    },
    changeAdditionUnder (index) {
      for (let i = index + 1; i < this.invoice_rows.products.length; i++) {
        this.invoice_rows.products[i].addition = this.invoice_rows.products[index].old_addition_fixed || this.invoice_rows.products[index].addition
        this.inputAdditionProduct(i)
        this.changeAdditionDiscountProduct(i)
      }
    },
    changeDiscountUnder (index) {
      for (let i = index + 1; i < this.invoice_rows.products.length; i++) {
        this.invoice_rows.products[i].discount = this.invoice_rows.products[index].old_discount_fixed || this.invoice_rows.products[index].addition
        this.inputDiscountProduct(i)
        this.changeAdditionDiscountProduct(i)
      }
    }
  },
  mounted () {
    let vm = this
    this.compHistory = setInterval(() => {
      let pendingInvoice = {
        invoice_rows: vm.invoice_rows
      }
      localforage.setItem('pending_invoice', pendingInvoice)
    }, 2000)
    document.getElementById('composition-template-event').addEventListener('keydown', event => {
      let element = document.getElementById('product-slideout')

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-price-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataPriceActive = vm.lastDataPriceActive == null ? 0 : vm.lastDataPriceActive + 1
          if (vm.lastDataPriceActive === vm.invoice_rows.products.length) {
            vm.lastDataPriceActive--
          }
        } else {
          vm.lastDataPriceActive = vm.lastDataPriceActive < 1 ? 0 : vm.lastDataPriceActive - 1
        }
        window.$('[data-price-active=' + vm.lastDataPriceActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-addition-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataAdditionActive = vm.lastDataAdditionActive == null ? 0 : vm.lastDataAdditionActive + 1
          if (vm.lastDataAdditionActive === vm.invoice_rows.products.length) {
            vm.lastDataAdditionActive--
          }
        } else {
          vm.lastDataAdditionActive = vm.lastDataAdditionActive < 1 ? 0 : vm.lastDataAdditionActive - 1
        }
        window.$('[data-addition-active=' + vm.lastDataAdditionActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-discount-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive == null ? 0 : vm.lastDataDiscountActive + 1
          if (vm.lastDataDiscountActive === vm.invoice_rows.products.length) {
            vm.lastDataDiscountActive--
          }
        } else {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive < 1 ? 0 : vm.lastDataDiscountActive - 1
        }
        window.$('[data-discount-active=' + vm.lastDataDiscountActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-qty-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataQtyActive = vm.lastDataQtyActive == null ? 0 : vm.lastDataQtyActive + 1
          if (vm.lastDataQtyActive === vm.invoice_rows.products.length) {
            vm.lastDataQtyActive--
          }
        } else {
          vm.lastDataQtyActive = vm.lastDataQtyActive < 1 ? 0 : vm.lastDataQtyActive - 1
        }
        window.$('[data-qty-active=' + vm.lastDataQtyActive + ']').focus().select()
      }

      if (event.keyCode === 8 && element.classList.contains('slideout-open') && document.activeElement.getAttribute('data-product') === null) {
        let searchProducts = document.getElementById('product-search')
        if (document.activeElement.closest('#product-slideout') !== null) {
          if (document.activeElement !== searchProducts) {
            searchProducts.focus()
          }
        }
      }
    })
  },
  async created () {
    this.priceCategoryes = ProductsService.getPriceCategories()
    var today = new Date()
    this.due_date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()
    this.userWarehouses = this.$store.getters.user.warehouses
    if (!this.$can(['view addition'])) {
      this.hideAddition = false
    }
    await this.getWarehouses()

    let vm = this
    await localforage.getItem('pending_invoice').then((pendingInvoice) => {
      if (pendingInvoice) {
        if (pendingInvoice.invoice_rows !== undefined) vm.invoice_rows = pendingInvoice.invoice_rows && pendingInvoice.invoice_rows.products ? pendingInvoice.invoice_rows : { products: [], services: [], post_services: [] }
      }
    })
    this.$store.dispatch('hideLoading')
  },
  computed: {
    start_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page > 2) {
        return parseInt(this.meta_products.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page + 2 < this.meta_products.last_page) {
        return parseInt(this.meta_products.current_page, 10) + 2
      } else {
        return this.meta_products.last_page
      }
    },
    // return only 5 pages for pagination
    products_pagination () {
      let pages = []
      for (let i = this.start_page_products; i <= this.stop_page_products; i++) {
        pages.push(i)
      }
      return pages
    },
    start_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page > 2) {
        return parseInt(this.meta_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page + 2 < this.meta_services.last_page) {
        return parseInt(this.meta_services.current_page, 10) + 2
      } else {
        return this.meta_services.last_page
      }
    },
    // return only 5 pages for pagination
    services_pagination () {
      let pages = []
      for (let i = this.start_page_services; i <= this.stop_page_services; i++) {
        pages.push(i)
      }
      return pages
    },
    start_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page > 2) {
        return parseInt(this.meta_post_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page + 2 < this.meta_post_services.last_page) {
        return parseInt(this.meta_post_services.current_page, 10) + 2
      } else {
        return this.meta_post_services.last_page
      }
    },
    // return only 5 pages for pagination
    post_service_pagination () {
      let pages = []
      for (let i = this.start_page_post_service; i <= this.stop_page_post_service; i++) {
        pages.push(i)
      }
      return pages
    },
    addition () {
      let totalMin = 0
      this.invoice_rows.products.forEach(function (element) {
        totalMin += parseFloat(element.prices.pp_minim).toFixed(2) * parseInt(element.qty)
      })
      let addition = []
      addition['value'] = (parseFloat(this.total).toFixed(4) - parseFloat(totalMin).toFixed(4)) / 1.19
      addition['percentage'] = ((100 * parseFloat(addition['value']).toFixed(2)) / parseFloat(totalMin / 1.19).toFixed(2)) || 0
      return addition
    },
    subtotal () {
      let subtotal = 0
      let subtotalProduct = 0
      let addition = 0
      let discount = 0
      this.invoice_rows.products.forEach(function (element) {
        subtotalProduct = 0
        addition = 0
        discount = 0
        subtotalProduct = element.price * element.qty
        // if (element.addition && element.addition !== 0) {
        //   addition = Math.abs(element.addition) / 100 * subtotalProduct
        // }
        // if (element.discount && element.discount !== 0) {
        //   discount = Math.abs(element.discount) / 100 * subtotalProduct
        // }
        // subtotal += subtotalProduct + addition - discount
        subtotal += subtotalProduct
      })
      this.invoice_rows.services.forEach(function (element) {
        subtotalProduct = 0
        addition = 0
        discount = 0
        subtotalProduct = element.price * element.qty
        if (element.addition && element.addition !== 0) {
          addition = Math.abs(element.addition) / 100 * subtotalProduct
        }
        if (element.discount && element.discount !== 0) {
          discount = Math.abs(element.discount) / 100 * subtotalProduct
        }
        subtotal += subtotalProduct + addition - discount
      })
      this.invoice_rows.post_services.forEach(function (element) {
        subtotalProduct = 0
        addition = 0
        discount = 0
        subtotalProduct = element.price * element.qty
        if (element.addition && element.addition !== 0) {
          addition = Math.abs(element.addition) / 100 * subtotalProduct
        }
        if (element.discount && element.discount !== 0) {
          discount = Math.abs(element.discount) / 100 * subtotalProduct
        }
        subtotal += subtotalProduct + addition - discount
      })
      return subtotal
    },
    total () {
      let total = this.subtotal
      let discount = this.discount
      if (discount < 0) {
        discount = 0
      }
      if (discount > 100) {
        discount = 100
      }
      if (discount > 0) {
        total = total - discount / 100 * total
      }
      return total
    }
  }
}
</script>
